import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

import { applicationContext } from '@philips-internal/oswald-ui-foundation/lib/context';

import { FragmentNames } from '../codegen';

@Controller({ fragment: FragmentNames.ROOT })
class MainController {

  @OnMount({ target: 'root-layout' })
  onRootLayoutMount(): void {
    document.title = MessageService.translate('application.name');
    applicationContext.setTitle(MessageService.translate('application.name'));
  }
}

export default MainController;
